import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  style: {
    "font-size": "18px",
    "color": "rgb(0, 119, 230)",
    "white-space": "nowrap"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$store.state.deviceState.mode == 1 ? "采集中" : "调试中") + "：" + _toDisplayString($setup.clock), 1)]);
}